const menuButton = document.querySelector("[data-menu]");
const navLinks = document.querySelector(".nav-links");
const ageKey = "livyatanAgeApproved";
const cookieKey = "livyatanCookieConsent";

function createSiteNotice() {
  if (!localStorage.getItem(ageKey)) {
    const ageGate = document.createElement("div");
    ageGate.className = "age-gate";
    ageGate.setAttribute("role", "dialog");
    ageGate.setAttribute("aria-modal", "true");
    ageGate.innerHTML = `
      <div class="age-gate-box">
        <span class="eyebrow">יקב לוויתן</span>
        <h2>האתר מיועד לבני 18 ומעלה</h2>
        <p>הכניסה לאתר כוללת מידע ורכישה של משקאות אלכוהוליים. יש לאשר שהנך מעל גיל 18.</p>
        <div class="age-actions">
          <button class="btn" type="button" data-age-approve>אני מעל גיל 18</button>
          <a class="btn secondary" href="https://www.google.com">יציאה</a>
        </div>
      </div>
    `;
    document.body.appendChild(ageGate);
    document.body.classList.add("modal-open");

    ageGate.querySelector("[data-age-approve]").addEventListener("click", () => {
      localStorage.setItem(ageKey, "true");
      ageGate.remove();
      document.body.classList.remove("modal-open");
      showCookieBanner();
    });
  } else {
    showCookieBanner();
  }
}

function showCookieBanner() {
  if (localStorage.getItem(cookieKey) || document.querySelector(".cookie-banner")) return;

  const banner = document.createElement("div");
  banner.className = "cookie-banner";
  banner.innerHTML = `
    <div>
      <strong>שימוש בעוגיות</strong>
      <p>אנחנו משתמשים בעוגיות לשיפור חוויית הגלישה, מדידה והתאמת תוכן באתר.</p>
    </div>
    <div class="cookie-actions">
      <button class="btn" type="button" data-cookie-accept>מאשר/ת</button>
      <button class="btn secondary" type="button" data-cookie-decline>לא עכשיו</button>
    </div>
  `;
  document.body.appendChild(banner);

  banner.querySelector("[data-cookie-accept]").addEventListener("click", () => {
    localStorage.setItem(cookieKey, "accepted");
    banner.remove();
  });

  banner.querySelector("[data-cookie-decline]").addEventListener("click", () => {
    localStorage.setItem(cookieKey, "declined");
    banner.remove();
  });
}

createSiteNotice();

if (menuButton && navLinks) {
  menuButton.addEventListener("click", () => navLinks.classList.toggle("open"));
  navLinks.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => navLinks.classList.remove("open"));
  });
  window.addEventListener("scroll", () => navLinks.classList.remove("open"), { passive: true });
}

document.querySelectorAll("[data-zoom]").forEach((zoom) => {
  const image = zoom.querySelector("img");
  if (!image) return;

  zoom.addEventListener("mousemove", (event) => {
    const rect = zoom.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    image.style.transformOrigin = `${x}% ${y}%`;
    zoom.classList.add("is-zooming");
  });

  zoom.addEventListener("mouseleave", () => {
    image.style.transformOrigin = "center";
    zoom.classList.remove("is-zooming");
  });
});

document.querySelectorAll("[data-countdown]").forEach((countdown) => {
  const target = new Date(countdown.dataset.countdown).getTime();
  const clock = countdown.querySelector("[data-countdown-clock]");
  const complete = countdown.querySelector("[data-countdown-complete]");
  const days = countdown.querySelector("[data-countdown-days]");
  const hours = countdown.querySelector("[data-countdown-hours]");
  const minutes = countdown.querySelector("[data-countdown-minutes]");
  const seconds = countdown.querySelector("[data-countdown-seconds]");

  if (!Number.isFinite(target) || !clock || !days || !hours || !minutes || !seconds) return;

  const pad = (value) => String(value).padStart(2, "0");
  const updateCountdown = () => {
    const remaining = target - Date.now();

    if (remaining <= 0) {
      clock.hidden = true;
      if (complete) complete.hidden = false;
      return false;
    }

    days.textContent = pad(Math.floor(remaining / 86400000));
    hours.textContent = pad(Math.floor((remaining % 86400000) / 3600000));
    minutes.textContent = pad(Math.floor((remaining % 3600000) / 60000));
    seconds.textContent = pad(Math.floor((remaining % 60000) / 1000));
    return true;
  };

  if (updateCountdown()) {
    const interval = window.setInterval(() => {
      if (!updateCountdown()) window.clearInterval(interval);
    }, 1000);
  }
});

const moneyFormatter = new Intl.NumberFormat("he-IL", {
  style: "currency",
  currency: "ILS",
  maximumFractionDigits: 0
});

const trackingCurrency = window.LivyatanTracking?.currency || "ILS";

function pushTrackingEvent(eventName, payload = {}) {
  window.dataLayer = window.dataLayer || [];
  if (payload.ecommerce) window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event: eventName, ...payload });
}

function cartItemToAnalyticsItem(item, quantityOverride) {
  const quantity = Number(quantityOverride ?? item.quantity ?? 1);
  const cents = Number(item.final_price ?? item.price ?? item.original_price ?? 0);
  return {
    item_id: String(item.product_id || item.id || item.variant_id || ""),
    item_name: item.product_title || item.title || "",
    item_category: item.product_type || "יין",
    item_variant: item.variant_title || item.variant_options?.join(" / ") || "",
    price: cents / 100,
    quantity
  };
}

function pushCartAdd(item) {
  const analyticsItem = cartItemToAnalyticsItem(item);
  const value = analyticsItem.price * analyticsItem.quantity;
  pushTrackingEvent("add_to_cart", {
    product_id: analyticsItem.item_id,
    product_name: analyticsItem.item_name,
    product_category: analyticsItem.item_category,
    variant: analyticsItem.item_variant,
    quantity: analyticsItem.quantity,
    currency: trackingCurrency,
    price: analyticsItem.price,
    ecommerce: {
      currency: trackingCurrency,
      value,
      items: [analyticsItem]
    }
  });
  pushTrackingEvent("AddToCart", {
    content_type: "product",
    content_ids: [analyticsItem.item_id],
    content_name: analyticsItem.item_name,
    value,
    currency: trackingCurrency,
    quantity: analyticsItem.quantity
  });
}

function pushCartRemove(item, quantityRemoved) {
  const analyticsItem = cartItemToAnalyticsItem(item, quantityRemoved);
  pushTrackingEvent("remove_from_cart", {
    product_id: analyticsItem.item_id,
    product_name: analyticsItem.item_name,
    product_category: analyticsItem.item_category,
    variant: analyticsItem.item_variant,
    quantity: analyticsItem.quantity,
    currency: trackingCurrency,
    price: analyticsItem.price,
    ecommerce: {
      currency: trackingCurrency,
      value: analyticsItem.price * analyticsItem.quantity,
      items: [analyticsItem]
    }
  });
}

function pushCheckoutStart(cart) {
  const items = (cart.items || []).map((item) => cartItemToAnalyticsItem(item));
  pushTrackingEvent("begin_checkout", {
    currency: trackingCurrency,
    transaction_value: (Number(cart.total_price) || 0) / 100,
    total_bottles: Number(cart.item_count) || 0,
    ecommerce: {
      currency: trackingCurrency,
      value: (Number(cart.total_price) || 0) / 100,
      items
    }
  });
  pushTrackingEvent("InitiateCheckout", {
    content_type: "product",
    value: (Number(cart.total_price) || 0) / 100,
    currency: trackingCurrency,
    contents: items.map((item) => ({ id: item.item_id, quantity: item.quantity }))
  });
}

function formatCartMoney(cents) {
  return moneyFormatter.format((Number(cents) || 0) / 100);
}

function getQuantityInput(scope) {
  return scope ? scope.querySelector("[data-quantity-input]") : null;
}

function normalizeQuantity(value, minimum = 1) {
  const quantity = Number.parseInt(value, 10);
  if (!Number.isFinite(quantity)) return minimum;
  return Math.max(minimum, quantity);
}

function setCartFeedback(form, message) {
  const feedback = form.querySelector("[data-cart-feedback]");
  if (!feedback) return;
  feedback.textContent = message;
  window.setTimeout(() => {
    if (feedback.textContent === message) feedback.textContent = "";
  }, 2600);
}

function updateCartBadges(cart) {
  document.querySelectorAll("[data-cart-count], [data-cart-item-count]").forEach((badge) => {
    badge.textContent = cart.item_count;
  });

  document.querySelectorAll("[data-cart-subtotal]").forEach((subtotal) => {
    subtotal.textContent = formatCartMoney(cart.items_subtotal_price);
  });

  document.querySelectorAll("[data-cart-total]").forEach((total) => {
    total.textContent = formatCartMoney(cart.total_price);
  });

  updateFreeShipping(cart);
}

function updateFreeShipping(cart) {
  const target = 50000;
  const total = Number(cart.total_price) || 0;
  const progress = Math.min(100, Math.max(0, (total / target) * 100));
  document.querySelectorAll("[data-free-shipping-bar]").forEach((bar) => { bar.style.width = `${progress}%`; });
  document.querySelectorAll("[data-free-shipping-message]").forEach((message) => {
    message.textContent = total >= target ? "זכאים למשלוח חינם באזורים רגילים" : `חסרים לך ${formatCartMoney(target - total)} למשלוח חינם`;
  });
}

function renderCartLine(item) {
  const image = item.image ? `<img src="${item.image}" alt="">` : "";
  const variant = item.variant_title && item.variant_title !== "Default Title" ? `<p>${item.variant_title}</p>` : "";
  const preorder = item.properties && String(item.properties._Preorder) === "true" ? `<span class="preorder-badge">רכישה מוקדמת</span>` : "";

  return `
    <div class="cart-line" data-cart-line data-cart-key="${item.key}">
      ${image}
      <div>
        <h3>${item.product_title}</h3>
        ${preorder}
        ${variant}
        <div class="qty-control" aria-label="כמות עבור ${item.product_title}">
          <button type="button" data-qty-adjust="-1" data-cart-key="${item.key}" aria-label="הפחתת כמות">-</button>
          <input type="number" value="${item.quantity}" min="0" inputmode="numeric" data-quantity-input data-cart-key="${item.key}" aria-label="כמות">
          <button type="button" data-qty-adjust="1" data-cart-key="${item.key}" aria-label="הוספת יחידה">+</button>
        </div>
        <button class="cart-remove" type="button" data-cart-remove data-cart-key="${item.key}">הסרה</button>
      </div>
      <strong data-line-price>${formatCartMoney(item.final_line_price)}</strong>
    </div>
  `;
}

const cartDrawerShell = document.querySelector("[data-cart-drawer-shell]");
const cartDrawer = document.querySelector("[data-cart-drawer]");
let cartDrawerCloseTimer;

function renderCartDrawer(cart) {
  const itemsNode = document.querySelector("[data-cart-drawer-items]");
  const footer = document.querySelector("[data-cart-drawer-footer]");
  if (!itemsNode || !footer) return;
  if (!cart.items.length) {
    itemsNode.innerHTML = `<div class="cart-drawer-empty"><h3>הסל שלך ריק</h3><p>אפשר להתחיל מהיינות של לוויתן ולהוסיף בקבוק ראשון להזמנה.</p><a class="btn" href="/collections/all-products">לחנות</a></div>`;
    footer.hidden = true;
  } else {
    itemsNode.innerHTML = cart.items.map(renderCartLine).join("");
    footer.hidden = false;
  }
  const hasPreorder = cart.items.some((item) => item.properties && String(item.properties._Preorder) === "true");
  const preorderNotice = document.querySelector("[data-drawer-preorder]");
  if (preorderNotice) preorderNotice.hidden = !hasPreorder;
  updateCartBadges(cart);
}

async function openCartDrawer() {
  if (!cartDrawerShell || !cartDrawer) return;
  window.clearTimeout(cartDrawerCloseTimer);
  cartDrawerShell.hidden = false;
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => cartDrawerShell.classList.add("is-open"));
  });
  document.body.classList.add("cart-drawer-open");
  try { renderCartDrawer(await getCart()); } catch (error) { window.location.href = "/cart"; return; }
  cartDrawer.focus();
}

function closeCartDrawer() {
  if (!cartDrawerShell) return;
  cartDrawerShell.classList.remove("is-open");
  document.body.classList.remove("cart-drawer-open");
  window.clearTimeout(cartDrawerCloseTimer);
  cartDrawerCloseTimer = window.setTimeout(() => {
    if (!cartDrawerShell.classList.contains("is-open")) cartDrawerShell.hidden = true;
  }, 300);
}

document.addEventListener("click", (event) => {
  if (event.target.closest("[data-cart-drawer-open]")) { event.preventDefault(); openCartDrawer(); }
  if (event.target.closest("[data-cart-drawer-close]")) closeCartDrawer();
});

document.addEventListener("keydown", (event) => { if (event.key === "Escape") closeCartDrawer(); });

function syncCartLines(cart) {
  const cartPanel = document.querySelector(".cart-panel");
  if (!cartPanel) return;

  cart.items.forEach((item) => {
    let line = Array.from(document.querySelectorAll("[data-cart-line]")).find((cartLine) => cartLine.dataset.cartKey === item.key);

    if (!line) {
      const heading = cartPanel.querySelector("h2");
      if (heading) heading.insertAdjacentHTML("afterend", renderCartLine(item));
      line = Array.from(document.querySelectorAll("[data-cart-line]")).find((cartLine) => cartLine.dataset.cartKey === item.key);
    }

    if (!line) return;
    const input = line.querySelector("[data-quantity-input]");
    const price = line.querySelector("[data-line-price]");
    if (input) {
      input.value = item.quantity;
      input.defaultValue = item.quantity;
    }
    if (price) price.textContent = formatCartMoney(item.final_line_price);
  });

  document.querySelectorAll("[data-cart-line]").forEach((line) => {
    const key = line.dataset.cartKey;
    if (!cart.items.some((item) => item.key === key)) line.remove();
  });
}

async function getCart() {
  const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
  if (!response.ok) throw new Error("Cart request failed");
  return response.json();
}

async function changeCartItem(key, quantity) {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify({ id: key, quantity })
  });

  if (!response.ok) throw new Error("Cart update failed");
  return response.json();
}

async function addToCart(form) {
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { Accept: "application/json" },
    body: new FormData(form)
  });

  if (!response.ok) throw new Error("Cart add failed");
  return response.json();
}

document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-qty-adjust]");
  if (!button) return;

  event.preventDefault();
  const control = button.closest(".qty-control");
  const input = getQuantityInput(control);
  if (!input) return;

  const isCartQuantity = Boolean(button.dataset.cartKey);
  const minimum = isCartQuantity ? 0 : 1;
  const previousQuantity = normalizeQuantity(input.value, minimum);
  const nextQuantity = previousQuantity + Number(button.dataset.qtyAdjust || 0);
  input.value = Math.max(minimum, nextQuantity);

  if (!isCartQuantity) return;

  button.disabled = true;
  try {
    let removedItem = null;
    const removedQuantity = Math.max(0, previousQuantity - Number(input.value));
    if (removedQuantity > 0) {
      const previousCart = await getCart();
      removedItem = previousCart.items.find((item) => item.key === button.dataset.cartKey);
    }
    const cart = await changeCartItem(button.dataset.cartKey, Number(input.value));
    if (removedItem && removedQuantity > 0) pushCartRemove(removedItem, removedQuantity);
    updateCartBadges(cart);
    syncCartLines(cart);
    renderCartDrawer(cart);
  } catch (error) {
    window.location.href = "/cart";
  } finally {
    button.disabled = false;
  }
});

document.addEventListener("change", async (event) => {
  const input = event.target.closest("[data-quantity-input][data-cart-key]");
  if (!input) return;

  input.value = normalizeQuantity(input.value, 0);
  try {
    const previousQuantity = Number(input.defaultValue || input.getAttribute("value") || 0);
    let removedItem = null;
    const removedQuantity = Math.max(0, previousQuantity - Number(input.value));
    if (removedQuantity > 0) {
      const previousCart = await getCart();
      removedItem = previousCart.items.find((item) => item.key === input.dataset.cartKey);
    }
    const cart = await changeCartItem(input.dataset.cartKey, Number(input.value));
    if (removedItem && removedQuantity > 0) pushCartRemove(removedItem, removedQuantity);
    input.defaultValue = input.value;
    updateCartBadges(cart);
    syncCartLines(cart);
    renderCartDrawer(cart);
  } catch (error) {
    window.location.href = "/cart";
  }
});

document.querySelectorAll(".ajax-cart-form").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const submit = form.querySelector("button[type='submit']");
    if (submit) submit.disabled = true;

    try {
      const addedItem = await addToCart(form);
      pushCartAdd(addedItem);
      const cart = await getCart();
      updateCartBadges(cart);
      syncCartLines(cart);
      renderCartDrawer(cart);
      setCartFeedback(form, "נוסף לסל");
      openCartDrawer();
      const upsellLine = form.closest(".cart-upsell .upsell-line");
      if (upsellLine) upsellLine.remove();
    } catch (error) {
      form.submit();
    } finally {
      if (submit) submit.disabled = false;
    }
  });
});

document.addEventListener("click", async (event) => {
  const removeButton = event.target.closest("[data-cart-remove]");
  if (!removeButton) return;
  removeButton.disabled = true;
  try {
    const previousCart = await getCart();
    const removedItem = previousCart.items.find((item) => item.key === removeButton.dataset.cartKey);
    const cart = await changeCartItem(removeButton.dataset.cartKey, 0);
    if (removedItem) pushCartRemove(removedItem, removedItem.quantity);
    updateCartBadges(cart);
    syncCartLines(cart);
    renderCartDrawer(cart);
  } catch (error) {
    window.location.href = "/cart";
  }
});

document.querySelectorAll("form[action*='/cart'][method='post']").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    if (!event.submitter || event.submitter.name !== "checkout") return;
    event.preventDefault();
    try {
      const cart = await getCart();
      pushCheckoutStart(cart);
    } catch (error) {
      pushTrackingEvent("begin_checkout", { currency: trackingCurrency });
      pushTrackingEvent("InitiateCheckout", { currency: trackingCurrency });
    }
    if (!form.querySelector("input[name='checkout']")) {
      const checkoutInput = document.createElement("input");
      checkoutInput.type = "hidden";
      checkoutInput.name = "checkout";
      checkoutInput.value = "checkout";
      form.appendChild(checkoutInput);
    }
    form.submit();
  });
});

document.querySelectorAll("form[action*='/contact']").forEach((form) => {
  form.addEventListener("submit", () => {
    const isNewsletter = form.querySelector("input[name='contact[tags]'][value*='newsletter']");
    const formName = isNewsletter ? "newsletter_signup" : "contact_form";
    const leadSource = isNewsletter ? "newsletter" : "contact";
    pushTrackingEvent("lead", {
      lead_source: leadSource,
      form_name: formName
    });
    pushTrackingEvent("Lead", {
      lead_source: leadSource,
      form_name: formName
    });
  });
});

document.querySelectorAll("a[href*='/pages/launch'], a[href*='/pages/subscription']").forEach((link) => {
  link.addEventListener("click", () => {
    pushTrackingEvent("lead", {
      lead_source: "wine_club",
      form_name: "wine_club_signup"
    });
    pushTrackingEvent("Lead", {
      lead_source: "wine_club",
      form_name: "wine_club_signup"
    });
  });
});

document.querySelectorAll("[data-select-item]").forEach((link) => {
  link.addEventListener("click", () => {
    const card = link.closest("[data-tracking-product]");
    if (!card) return;
    const item = {
      item_id: card.dataset.productId || "",
      item_name: card.dataset.productTitle || "",
      item_category: card.dataset.productCategory || "יין",
      item_variant: card.dataset.productVariant || "",
      price: Number(card.dataset.productPrice || 0),
      quantity: 1
    };
    pushTrackingEvent("select_item", {
      product_id: item.item_id,
      product_name: item.item_name,
      product_category: item.item_category,
      variant: item.item_variant,
      currency: trackingCurrency,
      price: item.price,
      ecommerce: {
        item_list_name: card.dataset.productList || "",
        items: [item]
      }
    });
  });
});
